import { Modal } from "react-bootstrap";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const AddBot = (props) => {
  const { handleSubmit, register, formState: { errors }, reset } = useForm()
  const { t } = useTranslation();

  const save = (data) => {
    props.createBot(data.botName);
    props.onHide();
    reset();
  };
  
  return (
    <>
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered>
        <form onSubmit={handleSubmit(save)}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("Create New Bot")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <div className="form-group">
              <label className="form-label">{t("Name")}</label>
              <input
                className={`form-control ${errors.botName ? 'is-invalid' : ''}`}
                type="text"
                name="botName"
                id="botName"
                placeholder="Enter bot name"
                {...register('botName', { required: "Bot name is required" })}
              />
              {errors.botName && <div className="invalid-feedback">{errors.botName.message}</div>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <input type="submit" value="Add Bot" className="button px-md-4 py-md-3" />
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default AddBot;
